import { createFileRoute } from "@tanstack/react-router";
import { PartnerPage } from "@/components/partners/PartnerPage";
import { PARTNER_NOT_FOUND, loadTutorSlug } from "@/components/partners/partner-route";
import { TutorSubjectPage } from "@/components/partners/TutorSubjectPage";
import { partnerNotFoundHead, tutorSubjectHead, tutorsMapHead } from "@/components/partners/tutors-map-head";

// Страница партнёра (ru, старый адрес без префикса — по нему ушли письма 3b до 14.10.2026; canonical — /ru/tutors/<slug>).
export const Route = createFileRoute("/tutors/$slug")({
  // Старый slug → 301 на текущий (хвост slug = начало id анкеты).
  // Код предмета с ≥ 3 анкетами — страница предмета (src/lib/tutor-subject-pages.ts).
  loader: ({ params }) => loadTutorSlug("ru", params.slug),
  // Нет loaderData — loader бросил notFound (анкеты нет): ответ 404, head с noindex.
  head: ({ params, loaderData }) =>
    !loaderData
      ? partnerNotFoundHead("ru")
      : loaderData.subject
        ? tutorSubjectHead("ru", loaderData.subject)
        : tutorsMapHead("ru", params.slug, loaderData.initial?.row, undefined, loaderData.pageCodes),
  notFoundComponent: function NotFound() {
    const { slug } = Route.useParams();
    return <PartnerPage lang="ru" slug={slug} initial={PARTNER_NOT_FOUND} />;
  },
  component: function Page() {
    const { slug } = Route.useParams();
    const { initial, nearby, pageCodes, subject } = Route.useLoaderData();
    if (subject) return <TutorSubjectPage lang="ru" subject={subject} />;
    return <PartnerPage lang="ru" slug={slug} initial={initial} nearby={nearby} pageCodes={pageCodes} />;
  },
});
